import { useCallback, useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import PropTypes from 'prop-types';

// material-ui
import { Avatar, Box, Button, FormControl, FormHelperText, Grid, OutlinedInput, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Landscape, KeyboardArrowDown } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';

// project imports
import { useDispatch, useSelector } from 'store';
import { connectStomp, disconnectStomp } from 'store/slices/campaign';
import Breadcrumbs from 'ui-component/breadcrumbs';
import { format, differenceInDays } from 'date-fns';
import { textAlign } from '@mui/system';

function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate and buffer variants.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
};

const PaymentPage = () => {
    const { workspaceId, orderId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const intl = useIntl();
    const stompClientRef = useRef(null);
    const { creativeProgress } = useSelector((state) => state.campaign);
    
    useEffect(() => {
        // connect();
        client.activate()
        // dispatch(connectStomp(orderId));
        // return () => dispatch(disconnectStomp());
    }, [dispatch, orderId]);

    const connect = () => {
        const socket = new SockJS("/ws", {
            transportOptions: {
              'xhr-streaming': {
                headers: {
                  "Authorization": `Bearer ${localStorage.getItem('accessToken')}`
                }
              }
            }
        });
        const stompClient = new Client({
            webSocketFactory: socket,
            connectHeaders: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
            },
            // brokerURL: 'ws://portal-stg.caterpillarai.io/ws', // 'ws://localhost:15674/ws'
            // connectHeaders: {
            //     "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
            // },
            reconnectDelay: 5000,
            debug: (str) => {
                console.log(str);
            },
            onConnect: () => {
                console.log("onConnected");
                // Subscribe to the Status Topic
                stompClient.subscribe("/topic/status", (payload) => {
                    console.log("onMessageReceived");
                    var message = JSON.parse(payload.body);
                });
            
                // Send orderId
                stompClient.send(
                    "/app/pm.status",
                {},
                JSON.stringify({ orderId: orderId })
                );
            },
            onStompError: (frame) => {
                console.error('Broker reported error: ' + frame.headers['message']);
                console.error('Additional details: ' + frame.body);
            },
        });

        stompClient.activate()
        // stompClientRef.current = stompClient;

        // const stompClient = Stomp.over(socket);

        // stompClient.connect({ "Authorization": `Bearer ${localStorage.getItem('accessToken')}` }, onConnected);
    }

    const client = new Client({
        brokerURL: 'ws://portal-stg.caterpillarai.io/ws', // 'ws://localhost:15674/ws'
        connectHeaders: {
            "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
        },
        debug: (str) => {
            console.log(str);
        },
        reconnectDelay: 5000,
        heartbeatIncoming: 1000,
        heartbeatOutgoing: 1000,
      });
      
    client.onConnect = function (frame) {
        console.log("onConnected" + frame);
        // Subscribe to the Status Topic
        client.subscribe("/user/topic/status", (payload) => {
            console.log("onMessageReceived");
            var message = payload.body //JSON.parse(payload.body);
            console.log(message);
        });
    
        // Send orderId
        client.publish({
            destination: "/app/status",
            body: orderId //JSON.stringify({ orderId: orderId })
        });
      };
      
      client.onStompError = function (frame) {
        // Will be invoked in case of error encountered at Broker
        console.error('Broker reported error: ' + frame.headers['message']);
        console.error('Additional details: ' + frame.body);
      };

    return (
        <>
            <Box sx={{ background: 'transparent', marginBottom: '40px' }}>
                <Breadcrumbs
                    pageInfo={[
                        {name: <FormattedMessage id="billing-title" />, url: null, current: true}
                    ]}
                />
            </Box>
            <LinearProgressWithLabel value={creativeProgress} />
            <Grid container spacing={5}>
            </Grid>
        </>
    );
};

export default PaymentPage;
